import { render, staticRenderFns } from "./WorkspaceSettings.vue?vue&type=template&id=c0996d1e"
import script from "./WorkspaceSettings.vue?vue&type=script&lang=js"
export * from "./WorkspaceSettings.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceSettings.vue?vue&type=style&index=0&id=c0996d1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports